/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Matrix_Legend_OptionalInputs */

const cs_portals_matrix_legend_optional = /** @type {(inputs: Portals_Matrix_Legend_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`volitelné`)
};

const en_portals_matrix_legend_optional = /** @type {(inputs: Portals_Matrix_Legend_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

/**
* | output |
* | --- |
* | "optional" |
*
* @param {Portals_Matrix_Legend_OptionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_legend_optional = /** @type {((inputs?: Portals_Matrix_Legend_OptionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_Legend_OptionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_legend_optional(inputs)
	return cs_portals_matrix_legend_optional(inputs)
});